export default __webpack_public_path__ + "static/media/mysteryBetLogo.fdb45c48.png";